(() => {
  "use strict";
  var e = {
      d: (t, n) => {
        for (var l in n)
          e.o(n, l) &&
            !e.o(t, l) &&
            Object.defineProperty(t, l, { enumerable: !0, get: n[l] });
      },
      o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
      r: (e) => {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(e, "__esModule", { value: !0 });
      },
    },
    t = {};
  e.r(t),
    e.d(t, {
      GloabalSidebarNav: () => GloabalSidebarNav,
      GlobalHeaderDropdown: () => GlobalHeaderDropdown,
      GlobalHeaderMain: () => GlobalHeaderMain,
    });
  class GlobalHeaderMain extends HTMLElement {
    constructor() {
      super(), this.headerHeightTimeout;
    }
    connectedCallback() {
      DomReadyPromise()
        .then(async () => {
          [
            "resize",
            "scroll",
            "announcement-bar-mutated",
            "header-dropdown-added",
          ].forEach((e) => {
            window.addEventListener(
              e,
              (e) => {
                clearTimeout(this.headerHeightTimeout),
                  (this.headerHeightTimeout = setTimeout(() => {
                    this.updateHeaderTotalHeight();
                  }, 100));
              },
              { passive: !0 }
            );
          });
        })
        .catch((e) => {
          console.log(e);
        });
    }
    updateHeaderTotalHeight() {
      let e = 0,
        t = 0,
        n = 0,
        l = 0;
      const a = document.getElementById("shopify-section-announcement-bar"),
        s = document.querySelector("global-header-main"),
        i = document.getElementById("shopify-section-header-below"),
        o = document.getElementById("shopify-section-countdown-timer");
      if ((document.body.offsetHeight, null != a)) {
        const l = a.getBoundingClientRect();
        l.bottom > 0 &&
          ((e += Math.max(0, l.height - Math.abs(l.top))),
          (t += Math.max(0, l.height - Math.abs(l.top))),
          (n += Math.max(0, l.height - Math.abs(l.top))));
      }
      if (
        (null != s &&
          ((e += s.getBoundingClientRect().height),
          (t += s.getBoundingClientRect().height),
          (n += s.getBoundingClientRect().height),
          (l += s.getBoundingClientRect().height)),
        null != o)
      ) {
        const t = o.getBoundingClientRect();
        t.bottom > 0 &&
          ((e += Math.max(0, t.height - Math.abs(t.top))),
          (n += Math.max(0, t.height - Math.abs(t.top))),
          (l += Math.max(0, t.height - Math.abs(t.top))));
      }
      null != i &&
        ((e += i.getBoundingClientRect().height),
        (t += i.getBoundingClientRect().height),
        (l += i.getBoundingClientRect().height)),
        document.body.style.setProperty(
          "--mh-total-height-no-top-Announcement",
          `${Math.round(l)}px`
        ),
        document.body.style.setProperty(
          "--mh-total-height-no-countdown",
          `${Math.round(t)}px`
        ),
        document.body.style.setProperty(
          "--mh-total-height",
          `${Math.round(e)}px`
        ),
        document.body.style.setProperty("--mh-height", `${Math.round(n)}px`);
    }
  }
  customElements.define("global-header-main", GlobalHeaderMain);
  class GlobalHeaderDropdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      DomReadyPromise()
        .then(() => {
          (this.template = this.querySelector("template")),
            this.parentElement.addEventListener("mouseenter", () => {
              this.unwrapTemplate();
            }),
            this.resizeTimeout,
            this.scrollTimeout,
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent("header-dropdown-added"));
            }, 0);
        })
        .catch((e) => {
          console.log(e);
        });
    }
    unwrapTemplate() {
      this.unwrapped ||
        ((this.unwrapped = !0), (this.innerHTML = this.template.innerHTML));
    }
  }
  function handleize(e) {
    return e
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }
  customElements.define("global-header-dropdown", GlobalHeaderDropdown);
  class GloabalSidebarNav extends HTMLElement {
    constructor() {
      super(), (this.ObserverLite = new ObserverLite());
    }
    subscribe(e) {
      return this.ObserverLite.subscribe(e);
    }
    next(e) {
      this.ObserverLite.next(e);
    }
    connectedCallback() {
      DomReadyPromise()
        .then(async () => {
          let e = this.querySelector(":scope > template");
          if (e) {
            try {
              (this.settings = JSON.parse(e.innerHTML)), e.remove();
            } catch (e) {
              return void this.remove();
            }
            e = null;
          }
          this.menuTrigger = document.getElementById("navMenuTrigger");
          const t = new ObserverLite({ key: "HeaderMainSectionDataProducer$" });
          
          (this.headerMainSectionData = await t.once());
          this.init();
        })
        .catch((e) => {
          console.error(e);
        });
    }
    init() {
      const e = document.getElementById("gorgias-chat-container");
      this.#e(e), this.menuTrigger.addEventListener("click", () => this.#e(e));
      const {
          main_list: t,
          secondary_list: n,
          section_settings: l,
        } = this.settings,
        { blocks: a } = this.headerMainSectionData;
      
      this.screens = [{ settings: { title: "main" } }];
      const s = [t, n].filter((e) => e?.length);
      (this.footerItems = (e = !1) =>
        `\n      <div class="bdr-t bdr-grey-3 flex ${
          e ? "" : " column-nowrap"
        } sidebar-nav__quick-links">\n        ${
          l.rewards__show && l.rewards__text.length && l.rewards__url
            ? `\n              <a href="${
                l.rewards__url
              }" class="sidebar-nav__footer-item sidebar-nav__footer-item--rewards no-hover">\n                ${
                e ? "" : l.rewards__text
              }\n              </a>`
            : ""
        }\n        ${
          l.wishlist__url && l.wishlist__show && l.wishlist__text.length
            ? `\n              <a href="${
                l.wishlist__url
              }" class="sidebar-nav__footer-item sidebar-nav__footer-item--wishlist no-hover">\n                ${
                e ? "" : l.wishlist__text
              }\n              </a>`
            : ""
        }\n        ${
          l.account__show && l.account__text.length
            ? `\n              <a href="/account" class="sidebar-nav__footer-item sidebar-nav__footer-item--account no-hover">\n                ${
                e ? "" : l.account__text
              }\n              </a>`
            : ""
        }\n        ${
          l.hc__show && l.hc__text.length && l.hc__url
            ? `\n              <a href="${
                l.hc__url
              }" class="sidebar-nav__footer-item sidebar-nav__footer-item--help no-hover">\n                ${
                e ? "" : l.hc__text
              }\n              </a>`
            : ""
        }\n        <global-country-selector class="country-selector country-selector--sidebar flex${
          e ? " country-selector--short" : ""
        }"></global-country-selector>\n      </div>\n    `),
        (this.innerHTML = `\n      <div class="sidebar-nav__screen column-nowrap gap sidebar-nav__ct--modal-close bg-grey-2" screen="main">\n        <div class="flex column-nowrap scroll-flex__scroll">\n          ${s
          .map(
            (e, t) =>
              `\n                <div class="sidebar-nav__menu block-top${
                0 != t ? " bdr-t bdr-grey-3" : ""
              }">\n                  ${e
                .map((e) => {
                  const t = a.find(({ settings: t }) => t.title == e.title);
                  return (
                    t && this.screens.push(t),
                    t
                      ? `<button class="btn-reset sidebar-nav__menu-item d-block" screen_toggle="${t.settings.title}"><span class="d-block text-left has-dropdown-chevron">${e.title}</span></button>`
                      : `<a class="sidebar-nav__menu-item" href="${e.url}">${e.title}</a>`
                  );
                })
                .join("")}\n                </div>\n              `
          )
          .join("")}\n          ${
          this.settings.blocks?.filter(({ image: e, link: t }) => e && t)
            ?.length
            ? `\n                <div class="bdr-t bdr-grey-3 flex column-nowrap gap--d3 sidebar-nav__carousel 1234567465312">\n                  ${
                l.cta_slider_heading?.length
                  ? `<h3 class="sidebar-nav__menu-title">${l.cta_slider_heading}</h3>`
                  : ""
              }\n                  <global-carousel class="d-block">\n                    <template>\n                      {\n                        "options":{ \n                          "loop": false,\n                          "skipSnaps": true\n                        }\n                      }\n                    </template>\n                    <div class="global-carousel__items block-rel cell-r">\n                      <div class="global-carousel__container flex-item-grid flex-item-grid--gap-d2 flex-item-grid--2 flex-item-grid--peek-50">\n                        ${this.settings.blocks
                ?.filter(({ image: e, link: t }) => e && t)
                .map((e, t) => {
                  const { title: n, badgeText: l } = this.#t(e.text);
                  return `\n                              <a href="${
                    e.link
                  }" class="global-carousel__slide global-carousel__slide--auto flex-item-grid__child flex column-nowrap gap--d3 block-rel">\n                                <img \n                                src="${
                    e.image
                  }" \n                                loading="lazy"\n                                alt="${
                    e.tile || `cta_${t}`
                  }" \n                                class="block-ar-1 block-12/12"\n                                width="256" \n                                height="256">\n\n                                  ${
                    n ? `<span class="f-w600 t-xxs lh-s">${n}</text>` : ""
                  }\n                                  ${
                    l ? this.#n(l, "product-card") : ""
                  }\n                              </a>\n                            `;
                })
                .join(
                  ""
                )}\n                      </div>\n                    </div>\n                  </global-carousel>\n                </div>\n              `
            : ""
        }\n          ${this.footerItems()}\n        </div>\n      </div>\n    `);
      
      const i = this.getScreen("main");
      (i.ui = this.querySelector('[screen="main"]')),
        this.bindScreenToggles(i.ui),
        (this.active_screen = i);
    }
    bindScreenToggles(e) {
      e.querySelectorAll("[screen_toggle]").forEach((e) =>
        e.addEventListener("click", (t) => {
          const n = e.attributes.screen_toggle.value;
          this.showScreen(n);
        })
      );
    }
    getScreen(e) {
      return this.screens.find(({ settings: t }) => t.title == e);
    }
    showScreen(e) {
      const t = this.getScreen(e);
      t.ui || this.renderScreen(t),
        this.animateOut(this.active_screen.ui),
        this.animateIn(t.ui),
        (this.active_screen = t);
    }
    animateIn(e) {
      (e.style.display = "flex"),
        (e.style.zIndex = "2"),
        (e.animate([{ opacity: 0 }, { opacity: 1 }], 150).onfinish = (t) => {
          e.style.opacity = 1;
        });
    }
    animateOut(e) {
      (e.style.zIndex = "1"),
        (e.animate([{ opacity: 1 }, { opacity: 0 }], 150).onfinish = (t) => {
          (e.style.opacity = 1), (e.style.display = "none");
        });
    }
    setDropdownHeights() {
      this.querySelectorAll(".nav-dropdown").forEach((e) => {
        const t = e.querySelector(".nav-dropdown__links-wrap");
        setTimeout(() => {
          0 !== Number(t?.scrollHeight) &&
            e.style.setProperty(
              "--dropdown-scroll-height",
              `${t.scrollHeight}px`
            );
        }, 0);
      });
    }
    renderScreen(e) {
      const { settings: t, links: n, type: l } = e,
        a = "6_cta" == l,
        s = n?.some((e) => e.links?.length) || !1;
      let i = [];
      s || a
        ? a || (i = n.map((e) => ({ title: e.title, links: e.links })))
        : i.push({
            title: !!t.list_heading?.length && t.list_heading,
            links: n,
          });
      const o =
          "no_cta" != l &&
          Object.keys(t)
            .filter((e) => e.includes("cta_"))
            .reduce((e, n) => {
              const l = n.match(/cta_(\d+)__/);
              if (l) {
                const a = l[1],
                  s = n.split("__")[1];
                e[a - 1] || (e[a - 1] = {});
                const i = t[n];
                i && (e[a - 1][s] = i);
              }
              return e;
            }, [])
            .filter((e) => e.image && e.link),
        r = o.length;
      let c = !1,
        d = 2,
        h = "block-ar-1 block-12/12 block-objc",
        g = !1;
      r &&
        ("2_cta_rect" == l &&
          ((h = "block-ar-2 block-12/12 block-objc"),
          (c = r > 1),
          (d = c ? 1.5 : 1)),
        "3_cta" == l && ((c = r > 2), (d = c ? 2.5 : 2)),
        "4_cta" == l && ((c = r > 2), (d = c ? 2.5 : 2)),
        (g = o.map((e, t) => {
          const { title: n, badgeText: a } = this.#t(e.title);
          return `\n          <img \n            src="${
            e.image
          }" \n            loading="lazy"\n            alt="${
            e.tile || `cta_${t}`
          }" \n            class="${h}"\n            width="256" \n            height="${
            "2_cta_rect" == l ? 256 : 128
          }">\n          ${
            n ? `<span class="f-w600 t-xs lh-s">${n}</span>` : ""
          }\n            ${
            e.desc ? `<span class="f-w600 t-xs lh-s">${e.desc}</span>` : ""
          }\n          ${
            e.text ? `<span class="f-w500 t-xs lh-xxs">${e.text}</span>` : ""
          }\n          ${a ? this.#n(a, "product-card") : ""}\n        `;
        })));
      let u =
        !!g &&
        `\n          ${
          t.cta_section__title?.length
            ? `<h3 class="sidebar-nav__menu-title">${t.cta_section__title}</h3>`
            : ""
        }\n          ${
          c
            ? `\n                <global-carousel class="d-block">\n                  <template>\n                    {\n                      "options":{ \n                        "loop": false,\n                        "skipSnaps": true\n                      }\n                    }\n                  </template>\n                  <div class="global-carousel__items block-rel cell-r">\n                    <div \n                      class="\n                        global-carousel__container flex-item-grid flex-item-grid--gap-d2 \n                        flex-item-grid--${Math.floor(
                d
              )} \n                        ${
                Number.isInteger(d) ? "" : "flex-item-grid--peek-50"
              }\n                      "\n                    >\n                      ${o
                .map(
                  (e, t) =>
                    `<a href="${e.link}" class="global-carousel__slide global-carousel__slide--auto flex-item-grid__child flex column-nowrap gap--d2 block-rel">${g[t]}</a>`
                )
                .join(
                  ""
                )}\n                    </div>\n                  </div>\n                </global-carousel>\n              `
            : `\n                <div class="sidebar-nav__menu-grid cell-r">\n                  ${o
                .map(
                  (e, t) =>
                    `\n                        <a \n                          href="${e.link}" \n                          style="flex: 0 1 50%;"\n                          class="flex column-nowrap gap--d2 product-single__thumbnails-item--small block-rel"\n                        >\n                          ${g[t]}\n                        </a>\n                      `
                )
                .join("")}\n                </div>\n              `
        }\n      `;
      const _ = `\n      <div \n        class="sidebar-nav__screen bg-grey-2"\n        screen="${
        e.settings.title
      }">\n        <div class="bdr-b bdr-grey-3">\n          <button class="sidebar-nav__screen_header-btn btn-reset t-rm f-w600" screen_toggle="main">${
        e.settings.title
      }</button>\n        </div>\n        <div \n          class="flex column-nowrap scroll-flex__scroll${
        a ? " cell-l ct cb" : ""
      }"\n        >\n          ${
        a
          ? ` \n            ${u}\n          `
          : `\n            ${i
              .map((e, n) => {
                const { title: l, badgeText: a } = this.#t(e.title);
                return `\n                  <div class="${
                  n < i.length - 1 ? " bdr-b bdr-grey-3" : ""
                }">\n                    <div class="nav-dropdown">\n                      ${
                  l
                    ? `\n                          <input type="checkbox" id="dropdown-toggle-${n}-${handleize(
                        l
                      )}" class="nav-dropdown__input visually-hidden"${
                        t.are_navs_collapsed ? "" : " checked"
                      } hidden>\n                          <label for="dropdown-toggle-${n}-${handleize(
                        l
                      )}" class="nav-dropdown__label cell-l cell-r">\n                            <h3 class="nav-dropdown__title-text has-dropdown-chevron f-w500 t-ucase ls-10 lh-1">\n                              ${l}\n                              ${
                        a ? this.#n(a, "nav-link") : ""
                      }\n                            </h3>\n                          </label>\n                        `
                    : ""
                }\n                      <div class="nav-dropdown__links-container">\n                        <ul class="nav-dropdown__links-wrap">\n                          ${e.links
                  .map((e) => {
                    const { title: t, badgeText: n } = this.#t(e.title);
                    return `\n                                <li>\n                                  <a class="nav-dropdown__link-item d-block" href="${
                      e.url
                    }">\n                                    <span class="f-w500 t-rm lh-20 cell-l cell-r">\n                                      ${
                      n ? this.#n(n, "nav-link") : ""
                    }\n                                      ${t}\n                                    </span>\n                                  </a>\n                                </li>\n                              `;
                  })
                  .join(
                    ""
                  )}\n                        </ul>\n                      </div>\n                    </div>\n                  </div>\n                `;
              })
              .join("")}\n          `
      }\n\n          ${
        u && !a
          ? `\n                <div class="cell-l ct cb bdr-t bdr-grey-3 flex grow-1 column-nowrap gap--d2">\n                  ${u}\n                </div>\n              `
          : ""
      }\n        </div>\n\n        ${
        t.view_all__text?.length && t.view_all__link
          ? `\n              <div class="bdr-t bdr-grey-3">\n                <a href="${t.view_all__link}" class="t-s f-w600 ct cb best-seller-link flex align-center cell-r">\n                  <span class="sidebar-nav__footer-item cell-l">\n                    ${t.view_all__text}\n                  </span>\n                </a>\n              </div>\n            `
          : ""
      }\n        ${
        t.footer__items
          ? this.footerItems("sidebar-nav__quick-links--short")
          : ""
      }\n      </div>\n    `;
      this.insertAdjacentHTML("beforeend", _),
        (e.ui = this.querySelector(`[screen="${e.settings.title}"]`)),
        this.bindScreenToggles(e.ui),
        this.setDropdownHeights();
    }
    #t(e) {
      return {
        title: e.replace(/\[[^\]]*\]/, ""),
        badgeText: (e.match(/\[([^\]]*)\]/) || [])[1] || null,
      };
    }
    #n(e, t) {
      return `<span class="badge-v2 badge-v2__${t}">${e}</span>`;
    }
    #e(e) {
      e && (e.style.zIndex = "0" == e.style.zIndex ? "1000" : "0");
    }
  }
  customElements.define("global-sidebar-nav", GloabalSidebarNav);
  var n = self;
  for (var l in t) n[l] = t[l];
  t.__esModule && Object.defineProperty(n, "__esModule", { value: !0 });
})();
